import { Typography } from "@material-ui/core";
import React from "react";

const Search = () => (
  <Typography style={{ padding: 20, textAlign: "center" }}>
    Nenhum resultado encontrado, pesquisa por{" "}
    <strong>telefone, email ou nome do contato</strong>
  </Typography>
);

const Todo = () => (
  <Typography style={{ padding: 20, textAlign: "center" }}>
    Você ainda não tem contatos{" "}
    <strong>Cadastre um novo contato ou aguarde um novo contato chegar</strong>
  </Typography>
);

const Activities = () => (
  <Typography style={{ padding: 20, textAlign: "center" }}>
    Aqui aparecem os contatos em que você marcou visitas de Follow-up (retornar
    para o cliente, enviar fotos e vídeos etc).
  </Typography>
);

const Visits = () => (
  <Typography style={{ padding: 20, textAlign: "center" }}>
    Aqui aparecem os contatos em que você agendou uma visita. Elas são
    precursoras de fechamentos no nosso mercado, portanto lembre‐se de manter o
    foco de seu atendimento em atrair os clientes para visitas
  </Typography>
);

const All = () => (
  <Typography style={{ padding: 20, textAlign: "center" }}>
    Cadastre um novo lead usando o botão azul flutuante abaixo ou aguarde um
    novo lead chegar
  </Typography>
);

const Favorite = () => (
  <Typography style={{ padding: 20, textAlign: "center" }}>
    Você não tem nenhum contato favoritado.
  </Typography>
);

const emptyMessages = {
  search: <Search />,
  todo: <Todo />,
  activities: <Activities />,
  visits: <Visits />,
  all: <All />,
  favorites: <Favorite />,
};

function EmptySection({ type }) {
  return emptyMessages[type];
}

export default EmptySection;
